<template>
	<div>
        <h3>Configuration</h3>

		<p>Type : {{type}}</p>

		<draggable :group="'mapping-' + id" :list="config.mapping" class="list-group" handle=".handle">
			<div v-for="(mapping, idx) in config.mapping" :key="idx">
				<p>Nom - identifiant
					<b-input v-model="mapping.name"></b-input>
				</p>
				<p>Libellé
					<b-input v-model="mapping.libelle"></b-input>
				</p>
				<p>Légende
					<b-textarea :rows="2" v-model="mapping.legend"></b-textarea>
				</p>
				<p>Type
					<b-select v-model="mapping.type" :options="[
						{value: 'mapping_columns', text: 'Mapping des colonnes'},
						{value: 'mapping_cells', text: 'Mapping des cellules'},
						{value: 'rules', text: 'Règles'},
					]"></b-select>
				</p>
				<p v-show="mapping.type == 'mapping_cells'">
					Colonne
					<b-input v-model="mapping.column"></b-input>
				</p>
				<p v-show="mapping.type != 'rules'">Valeurs
					<b-textarea :rows="10" v-model="mapping.values"></b-textarea>
				</p>
				<p v-show="mapping.type != 'rules'">Séparateur
					<b-input v-model="mapping.separator"></b-input>
				</p>
				<p v-show="mapping.type != 'rules'">Liste
					<b-select v-model="mapping.list" :options="lists"></b-select>
				</p>
				<b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
				<b-button variant="link" @click="del(idx)"><i class="fas fa-trash"></i></b-button>
				<hr />
			</div> 
		</draggable>

        <b-button variant="link" @click="new_mapping()"><i class="fas fa-plus"></i></b-button>
	</div>
</template>

<script>
	import draggable from "vuedraggable";
	import uniqueId from "lodash.uniqueid";

	import element from "../services/element.js";

	var clone = require("clone");

	export default {
		name: "config",
		components: {
			draggable
		},
		props: {
		},
		data() {
			return {
				id: uniqueId(""),
				type: "mapping",
				config: {
					mapping: []
				},
				lists: []
			};
		},
		watch: {
		},
		methods: {
			async load(data)
			{
				var self = this;

				this.type = data.type;
				this.config = data.config;

				for (var i = 0; i < this.config.mapping.length; i++)
				{
					this.config.mapping[i].values = this.config.mapping[i].values.join("\n");
				}
			},
			async save()
			{		
				var config = clone(this.config);		
				for (var i = 0; i < config.mapping.length; i++)
				{
					config.mapping[i].values = config.mapping[i].values.split("\n");
				}

				return {
					type: this.type,
					config: config
				}
			},
			new_mapping()
			{
				this.config.mapping.push({
					name: "",
					libelle: "",
					legend: "",
					type: "",
					column: "",
					values: "",
					separator: "|",
					list: ""
				})
			},
			del(idx)
			{
				this.config.mapping.splice(idx, 1);
			},
		},
		mounted: async function () {
			var lists = await element.getby_production("list");
			var lists = lists.element;

			for (var i = 0; i < lists.length; i++)
			{
				this.lists.push(lists[i].libelle)
			}
		},
	};
</script>

<style>
</style>
